import { PredefinedRuleSet, PredefinedRuleSetItem } from "../../Api/Dto/Responses/PredefinedRuleSet";
import { ServiceDefinitionWithItsRelatedCombos } from "./ComboServiceModel";
import { ServiceDefinitionContext } from "./CustomServiceModel";

class PredefinedRuleSetModel {
    public Model: PredefinedRuleSet;

    public static New(): PredefinedRuleSetModel {
        var ruleSet = new PredefinedRuleSetModel();
        ruleSet.Model = new PredefinedRuleSet;
        ruleSet.Model.PredefinedRuleSetItems = [];

        return ruleSet;
    }

    public Clone(): PredefinedRuleSetModel {
        var newRuleSet = new PredefinedRuleSetModel();
        newRuleSet.Model = JSON.parse(JSON.stringify(this.Model));

        return newRuleSet;
    }

    public AddRuleSetItem(ServiceDefinitionId: string): PredefinedRuleSetModel {
        // Already there
        if (this.Model.PredefinedRuleSetItems.some(x => x.ServiceDefinitionId == ServiceDefinitionId))
            return this;

        let ruleSetItem = new PredefinedRuleSetItem();
        ruleSetItem.Min = 1;
        ruleSetItem.Max = 1;
        ruleSetItem.ServiceDefinitionId = ServiceDefinitionId;

        this.Model.PredefinedRuleSetItems.push(ruleSetItem);

        return this;
    }

    public RemoveRuleSetItem(ServiceDefinitionId: string): PredefinedRuleSetModel {
        var newPredefinedRuleSet = this.Model.PredefinedRuleSetItems.filter(x => x.ServiceDefinitionId != ServiceDefinitionId);
        this.Model.PredefinedRuleSetItems = newPredefinedRuleSet;

        return this;
    }

    public ToComboServiceList(): ServiceDefinitionWithItsRelatedCombos[] {
        let result: ServiceDefinitionWithItsRelatedCombos[] = [];

        // group items by serviceDefinition
        let groupedByServices: { [serviceDefinitionId: string]: PredefinedRuleSetItem[] } = {};
        this.Model.PredefinedRuleSetItems.forEach(item => {
            if (Object.keys(groupedByServices).indexOf(item.ServiceDefinitionId) == -1)
                groupedByServices[item.ServiceDefinitionId] = [];
            groupedByServices[item.ServiceDefinitionId].push(item);
        });

        Object.keys(groupedByServices).forEach(x => {
            let rulesetItems = groupedByServices[x];

            if (rulesetItems != null && rulesetItems.length > 0) {
                let item = rulesetItems[0];
                let serviceCombo = new ServiceDefinitionWithItsRelatedCombos();

                var mainService = cacheStore.GetServiceDefinitionById(item.ServiceDefinitionId);
                var mainServiceSpecializationLookup = cacheStore.GetLookupById(mainService.GetSpecializationId());

                serviceCombo.Id = item.ServiceDefinitionId;
                serviceCombo.NameWithDuration = mainService.Name + " (" + mainService.GetDefaultDurationMinutes() + " min.)";
                serviceCombo.FullName = mainService.Name + " ( " + mainService.GetDefaultDurationMinutes() + " min. ) " + cacheStore.GetLocalizedValueByLookupId(mainServiceSpecializationLookup.LookupID);
                serviceCombo.Name = mainService.Name;
                serviceCombo.GroupMax = item.GroupMax;
                serviceCombo.HasCombo = rulesetItems.some(rs => rs.ComboId != null);
                serviceCombo.Checked = false;
                serviceCombo.Visible = true;
                serviceCombo.ServiceDefinitionId = item.ServiceDefinitionId;
                serviceCombo.ServiceDefinitionDuration = item.DurationMinutes * 600000000; // convert minutes to ticks
                serviceCombo.ServiceDefinitionSpecialityId = mainServiceSpecializationLookup.LookupID;
                serviceCombo.IsTeleconsultation = item.IsTeleconsultation;

                var relatedServices = rulesetItems.map(x => {
                    let defContext = new ServiceDefinitionContext();
                    defContext.IsCombo = x.ComboId != null;
                    defContext.Max = x.Max;
                    defContext.Min = x.Min;
                    defContext.TargetedClient = x.TargetedClient;
                    defContext.IsOnline = x.IsOnlineBookingAllowed;
                    defContext.Id = x.ID;
                    defContext.ComboId = parseInt(x.ComboId);
                    defContext.Checked = true;
                    defContext.Visible = true;
                    defContext.IsTeleconsultation = x.IsTeleconsultation;

                    let sd = x.ComboId != null ? null : cacheStore.GetServiceDefinitionById(x.ServiceDefinitionId);
                    let name = x.ComboId != null ? cacheStore.GetComboName(parseInt(x.ComboId)) : sd.Name;
                    defContext.Name = name;

                    return defContext;
                });

                serviceCombo.RelatedServiceDefinitionContexts = relatedServices;
                ServiceDefinitionWithItsRelatedCombos.SortRelatedServiceDefinitions(serviceCombo);

                result.push(serviceCombo);
            }
        });

        return result;
    }
}

export { PredefinedRuleSetModel };
